<template>
<div class="background">
  <div class="container-formCompletedPage">
		<div class="thank-you-page-confirm-text">
      <b style="color:red">
      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
      <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"></path>
      </svg>
      </b>
      Thanks!
      <br>
      <div class="h4">
      Your response was submitted.
      </div>
      <div class="auto-redirect h5">
      You will be redirected to home page automatically after {{countDown}} second
      </div>
		</div>
  </div>
</div>
</template>

<script>
const FormCompletedPage = {
name: "formCompletedPage",
  data() {
    return {
      countDown  : 5,
    };
  },
  methods: 
  {
    countDownTimer() {
            if(this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
            else{
              this.$router.push({name: 'home'})
            }
        }
    },
    created(){
      this.countDownTimer()
    }
}

export default FormCompletedPage;
</script>

<style scoped>
@import '../../../assets/styles/forms.css';

</style>